module.exports = __webpack_public_path__ + "static/media/Vela - LT Grey_DKChocolate.af497a43.jpg";